import { render } from "./delivery_component.vue?vue&type=template&id=065f7ecf&scoped=true"
import script from "./delivery_component.vue?vue&type=script&lang=js"
export * from "./delivery_component.vue?vue&type=script&lang=js"

import "./delivery_component.vue?vue&type=style&index=0&id=065f7ecf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-065f7ecf"]])

export default __exports__